appModule.controller('kpLoginController', ['$scope', '$rootScope', '$timeout', function ($scope, $rootScope, $timeout) {

}]);
